import React, { useContext, useEffect } from 'react';

import { OnboardingContext } from 'registration/containers/Onboarding';

import { pathToVariant } from 'shared/helpers/activateABTest';
import { trackComponentView } from 'shared/helpers/tracking';
import { TalentProfileType } from 'shared/types/TalentProfile';

import DefaultScheduledScreening from './DefaultScheduledScreening';

export const ScheduleScreening = () => {
  const { onboardingBasePath, onboardingData: talentProfile } =
    useContext(OnboardingContext);

  const variant = pathToVariant(onboardingBasePath);

  useEffect(
    () => trackComponentView('talent.onboarding.schedule', { variant }),
    [variant]
  );

  const pathRoot =
    talentProfile.type === TalentProfileType.TechProfile ? 'tech' : 'talent';
  return (
    <DefaultScheduledScreening nextAction={`/${pathRoot}/home#introCall`} />
  );
};

export default ScheduleScreening;
